/* eslint-disable no-use-before-define */

import xss from 'xss';

// const _ = require('lodash');
const dropDownInstances = require('./dropdown-instances');

export const siteSearch = () => {
    let searchPage = 1;
    let searchQuery = '';
    let orderBy = -1;
    let loadMoreEnabled = true;
    let culture = document.documentElement.lang;
    let isReload = false;
    let isFirstLoad = true;
    let tagParam = '';

    const searchInput = document.getElementById('search-input-form');
    const searchLoadMore = document.getElementById('search-result-load-more');
    const searchOrderBy = document.getElementById('search-orderby');
    const sitesearchSelectOptions = document.getElementById(
        'sitesearch-section-options'
    );
    const siteSearchButton = document.querySelector(
        '[data-lumc-id="site-search"]'
    );
    const styledSelectTriggerSitesearch = document.getElementsByClassName(
        'js-styled-select-trigger-sitesearch-orderby'
    )[0];
    const searchInputId = document.getElementById('search-input');

    const style = document.createElement('style');
    style.innerHTML = `.sub-select-active .icon-dropdown-cross {
        background-color: white !important;}`;

    $.urlParam = (name) => {
        const results = new RegExp(`[?&]${name}=([^&#]*)`).exec(
            window.location.search
        );

        return results !== null ? results[1] || 0 : false;
    };

    if (window.location.search && $.urlParam('query')) {
        // Reload the search results based on query params!

        // console.log(location.search);

        isReload = true;

        const searchOverlay = $('.search-overlay-block');
        const body = $('body');

        searchOverlay.removeClass('hidden-overlay-input');
        body.removeClass('light-theme');
        body.addClass('dark-theme');

        searchOverlay.removeAttr('hidden');

        if ($.urlParam('page')) {
            searchPage = $.urlParam('page');
        }

        if ($.urlParam('query')) {
            searchQuery = $.urlParam('query');
            searchQuery = decodeURI(searchQuery);

            $('#search-input').val(searchQuery);
        }

        if ($.urlParam('orderby')) {
            orderBy = $.urlParam('orderby');
        }

        if ($.urlParam('culture')) {
            culture = $.urlParam('culture');
        }

        if ($.urlParam('tag')) {
            tagParam = decodeURI($.urlParam('tag'));
        }

        // Get the correct query result, by including the tag value.
        doSearch(
            searchQuery,
            tagParam,
            searchPage,
            false,
            true,
            false,
            true,
            false,
            false,
            true
        );
    }

    if (searchInput) {
        searchInput.addEventListener('submit', (e) => {
            doSubmit(e);
        });

        searchInput.addEventListener('keydown', (event) => {
            const { key } = event;
            if (key === 'Backspace' || key === 'Delete') {
                const inputValue =
                    document.getElementById('search-input').value;
                if (inputValue.length < 3) {
                    document.getElementById('search-input').value = '';
                    $('#search-result-container').html('');
                    $('#search-result-count').hide();
                    $('#search-result-load-more').addClass('hidden');
                    generateFacetButtons(null);
                }

                return false;
            }
        });
    }

    if (searchLoadMore) {
        searchLoadMore.addEventListener('click', () => {
            if (!loadMoreEnabled) {
                return;
            }

            isReload = false;

            setLocation();

            loadMoreEnabled = false;

            const tag = getSection();

            doSearch(
                searchQuery,
                tag,
                searchPage,
                null,
                false, // Don't change facet values on load more
                true,
                true,
                false,
                true
            );
        });
    }

    if (searchOrderBy) {
        searchOrderBy.addEventListener('change', () => {
            if (orderBy === -1 || isReload) {
                orderBy = searchOrderBy.value;
                return;
            }

            orderBy = searchOrderBy.value;

            setLocation();

            const tag = getSection();

            doSearch(
                searchQuery,
                tag,
                1,
                null,
                false, // Don't change facet values on the changing of the sort order
                true,
                true,
                false,
                false
            );
        });
    }

    if (sitesearchSelectOptions) {
        sitesearchSelectOptions.addEventListener('change', () => {
            if (isFirstLoad) {
                return;
            }

            searchPage = 1;
            setLocation();

            searchQuery = $('#search-input').val();
            const tag = getSection();

            // eslint-disable-next-line prettier/prettier
            doSearch(
                searchQuery,
                tag,
                1,
                1,
                false, // Don't change facet values when changing the filter value
                false,
                true,
                false,
                false
            );
        });
    }

    if (siteSearchButton) {
        siteSearchButton.addEventListener('click', (e) => {
            doSubmit(e);
        });
    }

    if (styledSelectTriggerSitesearch) {
        styledSelectTriggerSitesearch.addEventListener('click', () => {
            isReload = false;
        });
    }

    function doSubmit(e) {
        e.preventDefault();

        isReload = false;
        isFirstLoad = true;

        setLocation();

        searchQuery = $('#search-input').val();

        const tag = getSection();

        // eslint-disable-next-line prettier/prettier
        doSearch(
            searchQuery,
            tag,
            1,
            2,
            true, // Determine the facet values when starting a new query
            false,
            true,
            false,
            true
        );
    }

    function doSearch(
        query,
        tag,
        page,
        newSearchPage,
        doGenerateFacetButtons,
        changedSortingValue,
        loadMoreEnabledValue,
        isReloadValue,
        increaseSearchPage,
        showMultiplePages
    ) {
        if (!query || query.length < 3) {
            return;
        }

        $.ajax({
            url: '/api/sitesearch',
            type: 'GET',
            dataType: 'json',
            data: {
                query,
                page,
                searchPage: newSearchPage,
                tag,
                culture,
                orderBy,
                changedSorting: changedSortingValue,
                isReload: isReloadValue,
                showMultiplePages,
            },
            success(result) {
                // console.log(result);

                if (!result) {
                    return;
                }

                if (result && increaseSearchPage) {
                    searchPage = result.Page + 1;
                } else if (newSearchPage) {
                    searchPage = newSearchPage;
                }

                searchQuery = result.Query;

                if (
                    result.DidYouMeanResult &&
                    result.DidYouMeanResult.Hits.length > 0
                ) {
                    const html = generateDidYouMeanHtml(
                        result.DidYouMeanResult
                    );
                    $('#search-result-container').html(html);
                } else {
                    const html = generateHtml(result.SearchResultItems);
                    $('#search-result-container').html(html);
                }

                setResultFeedback(result);

                if (result.ShowLoadMoreButton) {
                    $('#search-result-load-more').removeClass('hidden');
                } else {
                    $('#search-result-load-more').addClass('hidden');
                }

                if (doGenerateFacetButtons) {
                    generateFacetButtons(result);
                }

                loadMoreEnabled = loadMoreEnabledValue;
                isReload = isReloadValue;
                isFirstLoad = false;

                const autocompleteHolder = $('#autocomplete-holder');
                autocompleteHolder.hide();
            },
        });
    }

    function setLocation() {
        const query = $('#search-input').val();
        const tag = getSection();
        const orderby = $('#search-orderby option:selected').val();

        window.history.pushState(
            null,
            null,
            `${window.location.pathname}?query=${encodeURI(
                query
            )}&tag=${encodeURI(
                tag
            )}&page=${searchPage}&culture=${culture}&orderby=${orderby}`
        );
    }

    function generateHtml(searchResults) {
        let html = '';

        $.each(searchResults, (i, searchResult) => {
            html += `
                    <div>
                        <a href="${searchResult.Url}" class="search-result-item">
                            <h3>${searchResult.Title}</h3>
                            <span class="search-result-type">${searchResult.Tag}</span>
                            <p>
                                ${searchResult.Description}
                            </p>
                        </a>
                    </div>`;
        });

        return html;
    }

    function generateDidYouMeanHtml(didYouMeanResult) {
        let html = 'Bedoelde u ';

        $.each(didYouMeanResult.Hits, (i, hit) => {
            html += `
                    <div>
                        <a href="?query=${hit.Suggestion}">
                            ${hit.Suggestion} ?
                        </a>
                    </div>`;
        });

        return html;
    }

    function generateFacetButtons(result) {
        const sectionOptionsSelect = $('#sitesearch-section-options');

        const siteSearchSectionFilterButton = document.getElementById(
            'sitesearch-sectionfilter-button'
        );

        siteSearchSectionFilterButton.style.display = 'block';

        const facets = result.Facets;

        let sectionOptionsHtml = '';

        const searchSectionFacet = facets.filter(
            (item) => item.Name === 'SearchSection'
        );

        const termsList = searchSectionFacet[0].TermsList;

        const tag = decodeURIComponent(tagParam);

        sectionOptionsHtml = `${sectionOptionsHtml}<option name='site-search-tags' value='default'>${result.AllSectionsTextWithCount}</option>`;

        termsList.forEach((term) => {
            let selected = '';

            if (term.Term === tag) {
                selected = " selected='selected'";
            }

            sectionOptionsHtml = `${sectionOptionsHtml}<option name='site-search-tags' value='${term.Term}'${selected}>${term.Term} (${term.Count})</option>`;
        });

        sectionOptionsSelect.html(sectionOptionsHtml);

        const button = dropDownInstances.siteSearchSectionButton;

        if (button) {
            button.reset();
        }
    }

    function cleanInput(strInput) {
        let transformedInput = xss(strInput);

        if (
            transformedInput.includes('%3C') ||
            transformedInput.includes('%3E') ||
            transformedInput.toLowerCase().includes('script')
        ) {
            transformedInput = '';
        }

        return transformedInput;
    }

    function getSection() {
        if (isReload) {
            let queryStringTag = $.urlParam('tag');

            queryStringTag = cleanInput(queryStringTag);

            if (queryStringTag) {
                const decodedTag = decodeURIComponent(queryStringTag);
                return decodedTag;
            }
            return '';
        }

        const sectionOptions = document.getElementById(
            'sitesearch-section-options'
        );

        if (sectionOptions) {
            let section = sectionOptions.value;
            if (section === 'default') {
                section = '';
            }

            return section;
        }

        return '';
    }

    function setResultFeedback(result) {
        const section = getSection();

        let feedbackText = '';

        if (section) {
            feedbackText = `${
                result.TotalResultsText
            } in ${section.toLowerCase()}`;
        } else if (result) {
            feedbackText = `${
                result.TotalResultsText
            } in ${result.AllSectionsText.toLowerCase()}`;
        } else {
            feedbackText = '';
        }
        const item = $('#search-result-count');

        item.show();

        item.html(feedbackText);
    }

    if (searchInputId) {
        // $(searchInputId).on('keydown', (event) => {
        //     const TAB = 9;
        //     if (event.keyCode === TAB) {
        //         event.preventDefault();
        //     }
        // });

        const icons = `<svg class="icon-arrow-bottom-left" viewbox="0 0 10 10" width="10" height="10">
            <use xlink:href="/static/lumc/img/svg/sprite.svg#icon-arrow-bottom-left"></use>
            </svg>`;

        $(searchInputId).autocomplete({
            source(request, response) {
                $.ajax({
                    url: '/api/autocomplete',
                    type: 'GET',
                    dataType: 'json',
                    data: { query: $('#search-input').val(), culture },
                    success(data) {
                        const autocompleteHolder = $('#autocomplete-holder');
                        autocompleteHolder.show();

                        response(
                            $.map(data, (item) => ({
                                label: item,
                                value: item,
                            }))
                        );
                    },
                });
            },
            minLength: 2,
            delay: 500,
            appendTo: '#autocomplete-holder',
            create() {
                // eslint-disable-next-line func-names,no-underscore-dangle
                $(this).data('ui-autocomplete')._renderItem = function (
                    ul,
                    item
                ) {
                    return $('<a>')
                        .addClass('autocomplete-result')
                        .attr('data-value', item.value)
                        .append(`<p>${item.label}</p>${icons}`)
                        .appendTo(ul);
                };
            },
            focus() {
                // prevent value inserted on focus
                return false;
            },
            select(event, ui) {
                event.preventDefault();
                $(this).val(ui.item.label);
                doSubmit(event);
            },
        });
    }

    // Reset the search form and querystring on closing of the search layover.
    const closeOverlayTarget = document.querySelector('.pancake-close');
    const searchOverlay = document.querySelector('.search-overlay-block');

    if (closeOverlayTarget) {
        closeOverlayTarget.addEventListener('click', () => {
            if (searchOverlay) {
                window.history.pushState(null, null, window.location.pathname);
                window.location.reload();
            }
        });
    }
};
